import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionStatus, config, AuctionBid, AuctionService, AuctionQuery, BalanceQuery, BalanceService, ErrorStateService, SignalRHub, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgbCarouselConfig, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { utc } from 'moment';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { NumberInputModule } from '@fgb/portal-component-library/src/lib/shared/number-input';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { RouterModule } from '@angular/router';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { ConfirmModalModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/shared/errors';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/shared/countdown';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/shared/confirm-modal';
import * as ɵngcc8 from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import * as ɵngcc9 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc10 from '@fgb/portal-component-library/src/lib/shared/number-input';
import * as ɵngcc11 from '@ngx-translate/core';
import * as ɵngcc12 from '@fgb/portal-component-library/src/lib/pipes';

function AuctionDetailsComponent_div_0_ng_container_4_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 31);
    ɵngcc0.ɵɵpipe(1, "contentImage");
} if (rf & 2) {
    const image_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind3(1, 4, image_r11.ImageUrl, "7", "auction"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("alt", image_r11.ImageUrl);
    ɵngcc0.ɵɵproperty("useDefault", true)("loyaltyType", "marketplace");
} }
function AuctionDetailsComponent_div_0_ng_container_4_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AuctionDetailsComponent_div_0_ng_container_4_2_ng_template_0_Template, 2, 8, "ng-template", 30);
} }
function AuctionDetailsComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ngb-carousel");
    ɵngcc0.ɵɵtemplate(2, AuctionDetailsComponent_div_0_ng_container_4_2_Template, 1, 0, undefined, 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const auction_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", auction_r1.Images);
} }
function AuctionDetailsComponent_div_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 31);
    ɵngcc0.ɵɵpipe(1, "contentImage");
} if (rf & 2) {
    const auction_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind3(1, 4, auction_r1.ImageUrl, "7", "auction"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("alt", auction_r1.ItemName)("useDefault", true)("loyaltyType", "marketplace");
} }
function AuctionDetailsComponent_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵelementStart(1, "span", 33);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "auction.winning.status"));
} }
function AuctionDetailsComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵelementStart(1, "span", 33);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "auction.outbid.status"));
} }
const _c0 = function (a0) { return { minBid: a0 }; };
function AuctionDetailsComponent_div_0_div_38_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵelementStart(1, "fgbcl-number-input", 36);
    ɵngcc0.ɵɵlistener("amountChange", function AuctionDetailsComponent_div_0_div_38_Template_fgbcl_number_input_amountChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.bidAmount = $event; })("outOfRangeChange", function AuctionDetailsComponent_div_0_div_38_Template_fgbcl_number_input_outOfRangeChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.isBidOutOfRange = $event; });
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const auction_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("isActive", ctx_r7.auctionEnd || ctx_r7.comingSoon || ctx_r7.isWinning && !auction_r1.AllowSelfBid ? false : true)("minValue", auction_r1.HasPreviousSuccessfulBid ? ctx_r7.currentValue + auction_r1.BidIncrement : ctx_r7.currentValue)("maxValue", ctx_r7.availableBalance)("incrementValue", auction_r1.BidIncrement)("minMessage", ɵngcc0.ɵɵpipeBind2(2, 9, "error.auctionBid-valueLowerThanMinimumBidValue", ɵngcc0.ɵɵpureFunction1(14, _c0, ctx_r7.minBidAmount)))("maxMessage", ɵngcc0.ɵɵpipeBind1(3, 12, "error.user-insufficientFunds"))("amount", ctx_r7.bidAmount)("outOfRange", ctx_r7.isBidOutOfRange)("limitValueToRange", false);
} }
function AuctionDetailsComponent_div_0_ng_template_49_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 37);
    ɵngcc0.ɵɵelementStart(1, "b", 38);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hr", 39);
    ɵngcc0.ɵɵelementStart(5, "div", 40);
    ɵngcc0.ɵɵelementStart(6, "div", 41);
    ɵngcc0.ɵɵelement(7, "img", 42);
    ɵngcc0.ɵɵpipe(8, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 43);
    ɵngcc0.ɵɵelementStart(10, "div", 44);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 45);
    ɵngcc0.ɵɵelementStart(13, "span", 33);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵpipe(15, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "span");
    ɵngcc0.ɵɵtext(17);
    ɵngcc0.ɵɵpipe(18, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const auction_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 8, "auction.confirm.text"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵpropertyInterpolate("src", ɵngcc0.ɵɵpipeBind3(8, 10, auction_r1.ImageUrl, "7", "auction"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("alt", auction_r1.ImageUrl);
    ɵngcc0.ɵɵproperty("useDefault", true)("loyaltyType", "auction");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(auction_r1.ItemName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(15, 14, "auction.points.value"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(18, 16, ctx_r9.bidAmount), "");
} }
function AuctionDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelement(1, "fgbcl-errors");
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵtemplate(4, AuctionDetailsComponent_div_0_ng_container_4_Template, 3, 1, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(5, AuctionDetailsComponent_div_0_ng_template_5_Template, 2, 8, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementStart(7, "div", 6);
    ɵngcc0.ɵɵelement(8, "fgbcl-loyalty-icon", 7);
    ɵngcc0.ɵɵelementContainerStart(9, 8);
    ɵngcc0.ɵɵtemplate(10, AuctionDetailsComponent_div_0_div_10_Template, 4, 3, "div", 9);
    ɵngcc0.ɵɵtemplate(11, AuctionDetailsComponent_div_0_div_11_Template, 4, 3, "div", 10);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 11);
    ɵngcc0.ɵɵelementStart(13, "h2", 12);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 13);
    ɵngcc0.ɵɵelementStart(16, "div", 14);
    ɵngcc0.ɵɵelementStart(17, "div", 15);
    ɵngcc0.ɵɵelementStart(18, "span", 16);
    ɵngcc0.ɵɵpipe(19, "translate");
    ɵngcc0.ɵɵtext(20, "emoji_events");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "span", 17);
    ɵngcc0.ɵɵtext(22);
    ɵngcc0.ɵɵpipe(23, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 15);
    ɵngcc0.ɵɵelementStart(25, "span", 16);
    ɵngcc0.ɵɵpipe(26, "translate");
    ɵngcc0.ɵɵtext(27, "gavel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "span", 17);
    ɵngcc0.ɵɵtext(29);
    ɵngcc0.ɵɵpipe(30, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 15);
    ɵngcc0.ɵɵelementStart(32, "span", 16);
    ɵngcc0.ɵɵpipe(33, "translate");
    ɵngcc0.ɵɵtext(34, "schedule");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(35, "fgbcl-countdown", 18);
    ɵngcc0.ɵɵlistener("complete", function AuctionDetailsComponent_div_0_Template_fgbcl_countdown_complete_35_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.auctionEnd = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "div", 19);
    ɵngcc0.ɵɵelementStart(37, "div", 20);
    ɵngcc0.ɵɵtemplate(38, AuctionDetailsComponent_div_0_div_38_Template, 4, 16, "div", 21);
    ɵngcc0.ɵɵelementStart(39, "div", 22);
    ɵngcc0.ɵɵelementStart(40, "button", 23);
    ɵngcc0.ɵɵlistener("confirm", function AuctionDetailsComponent_div_0_Template_button_confirm_40_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.submitBid(); });
    ɵngcc0.ɵɵtext(41);
    ɵngcc0.ɵɵpipe(42, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(43, "div", 24);
    ɵngcc0.ɵɵelementStart(44, "label", 25);
    ɵngcc0.ɵɵtext(45);
    ɵngcc0.ɵɵpipe(46, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(47, "hr", 26);
    ɵngcc0.ɵɵelement(48, "fgbcl-short-long-description", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(49, AuctionDetailsComponent_div_0_ng_template_49_Template, 19, 18, "ng-template", null, 28, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const auction_r1 = ctx.ngIf;
    const _r3 = ɵngcc0.ɵɵreference(6);
    const _r8 = ɵngcc0.ɵɵreference(50);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", auction_r1.Images && auction_r1.Images.length > 1)("ngIfElse", _r3);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngSwitch", auction_r1.Status);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.auctionStatus.UserWinning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", ctx_r0.auctionStatus.UserLosing);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(auction_r1.ItemName);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(19, 19, "auction.details.points.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(23, 21, ctx_r0.currentValue), " Pts");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(26, 23, "auction.details.bids.count.screenreader"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(30, 25, ctx_r0.bidsCount), " Bids");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(33, 27, "auction.details.countdown.screenreader"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("endDateTime", ctx_r0.endDate);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.auctionEnd || ctx_r0.comingSoon || auction_r1.PointsValue > ctx_r0.availableBalance || ctx_r0.isWinning && !auction_r1.AllowSelfBid ? false : true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.isWinning && !auction_r1.AllowSelfBid || ctx_r0.comingSoon || ctx_r0.bidAmount > ctx_r0.availableBalance || ctx_r0.auctionEnd || ctx_r0.isBidOutOfRange)("confirmContent", _r8)("valid", !ctx_r0.auctionEnd);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(42, 29, ctx_r0.statusText), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(46, 31, "auction.description"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("description", auction_r1.ItemDescription);
} }
class AuctionDetailsComponent {
    constructor(auctionService, auctionQuery, balanceQuery, balanceService, errorService, carouselConfig, signalRHub) {
        this.auctionService = auctionService;
        this.auctionQuery = auctionQuery;
        this.balanceQuery = balanceQuery;
        this.balanceService = balanceService;
        this.errorService = errorService;
        this.carouselConfig = carouselConfig;
        this.signalRHub = signalRHub;
        this.auctionStatus = AuctionStatus;
        this.auctionEnd = false;
        this.isBidOutOfRange = false;
        this.theme = 'primary';
        this._destroyed$ = new Subject();
        this.config = config;
    }
    ngOnInit() {
        this.signalRHub
            .joinGroup('AuctionDetails_' + this.auctionId)
            .pipe(takeUntil(this._destroyed$))
            .subscribe();
        this.auction$ = this.auctionQuery.selectAuction(this.auctionId).pipe(tap((auction) => {
            if (auction) {
                this.minBidAmount = auction.HasPreviousSuccessfulBid
                    ? auction.CurrentValue + auction.BidIncrement
                    : auction.CurrentValue;
                this.bidAmount = this.minBidAmount;
                this.isWinning = !!auction.IsWinning;
                this.bidsCount = auction.BidsCount;
                this.currentValue = auction.CurrentValue;
                this.endDate = auction.EndDate;
                this.bidIncrement = auction.BidIncrement;
                this.comingSoon = auction.ComingSoon && utc(auction.StartDate) > utc();
                this._updateStatus(auction);
                this.availableBalanceSub = this.balanceQuery.selectPurse(this.config.purseConfig.virtualLoyalty).subscribe((bal) => {
                    this.availableBalance = bal !== null && bal !== void 0 ? bal : 0;
                    if (this.isWinning) {
                        this.availableBalance += auction.UserLastBid;
                    }
                });
            }
        }));
        this.auctionStatus$ = this.auctionQuery.selectAuctionStatus(this.auctionId);
        this.availableBalanceSub = this.balanceQuery.selectPurse(this.config.purseConfig.virtualLoyalty).subscribe((bal) => {
            this.availableBalance = bal !== null && bal !== void 0 ? bal : 0;
        });
        this.updateCarouselConfig();
    }
    ngOnDestroy() {
        if (this.availableBalanceSub) {
            this.availableBalanceSub.unsubscribe();
        }
        this.signalRHub.removeFromGroup('AuctionDetails_' + this.auctionId);
        this._destroyed$.next();
        this._destroyed$.complete();
    }
    submitBid() {
        // Submit the bid
        const bid = new AuctionBid(this.auctionId, +this.bidAmount);
        let amountToDebit = this.bidAmount;
        if (this.isWinning) {
            let auction = this.auctionQuery.getEntity(this.auctionId);
            if (auction) {
                amountToDebit -= auction.UserLastBid;
            }
        }
        this.auctionService
            .postBid(bid)
            .toPromise()
            .then(() => this.balanceService.debitBalance(this.config.purseConfig.virtualLoyalty, amountToDebit));
    }
    _updateStatus(auctionItem) {
        if (this.comingSoon) {
            this.statusText = 'auction.coming.soon';
            this.theme = 'secondary';
        }
        else if (auctionItem.PointsValue > this.availableBalance) {
            this.statusText = 'auction.not.enough.points';
            this.theme = 'secondary';
        }
        else {
            this.statusText = 'auction.bid.now';
            this.theme = 'auction';
        }
    }
    /**
     * Customise carousel
     * config if needed for
     * auction items which have
     * multiple auction images.
     */
    updateCarouselConfig() {
        this.carouselConfig.showNavigationIndicators = false;
        this.carouselConfig.interval = 3000;
    }
}
AuctionDetailsComponent.ɵfac = function AuctionDetailsComponent_Factory(t) { return new (t || AuctionDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AuctionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AuctionQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BalanceQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BalanceService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ErrorStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbCarouselConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SignalRHub)); };
AuctionDetailsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuctionDetailsComponent, selectors: [["fgbcl-auction-details"]], inputs: { auctionId: "auctionId" }, decls: 2, vars: 3, consts: [["class", "container", 4, "ngIf"], [1, "container"], [1, "d-block", "d-lg-flex", "mt-lg-3", "pt-lg-3"], [1, "loyalty-details-image", "card", "shadow", "rounded", "border-0", "overflow-hidden", "p-0"], [4, "ngIf", "ngIfElse"], ["singleImage", ""], [1, "card-img-overlay", "d-flex", "flex-column", "justify-content-between", "p-0"], ["loyaltyType", "auction", 1, "corner-icon", "bg-auction", "text-on-auction"], [3, "ngSwitch"], ["class", "status winning position-absolute p-0 text-center text-on-success font-size-14", 4, "ngSwitchCase"], ["class", "status outbid position-absolute p-0 text-center text-on-success font-size-14", 4, "ngSwitchCase"], [1, "loyalty-details", "w-100"], [1, "auction-detail-name", "mt-0", "pl-0", "pl-lg-3", "pt-4", "pt-lg-0"], [1, "card-body", "d-flex", "flex-column", "justify-content-between", "pr-3", "pl-0", "pl-lg-3", "pb-4", "pt-2", "pt-lg-3"], [1, "row", "mb-2"], [1, "col-6", "col-lg-4", "d-flex", "align-items-center", "pb-3"], ["role", "img", 1, "icon", "material-icons", "auction-icons-color", "mr-2"], [1, "font-size-18", "pt-1"], [1, "font-size-18", "pt-1", "countdown-color", 3, "endDateTime", "complete"], [1, "row", "pt-lg-4"], [1, "d-flex", "pl-2", "p-0"], ["class", "mb-3 mb-lg-0 mr-4 justify-content-center align-items-center", 4, "ngIf"], [1, "d-flex", "mr-3"], ["confirmModal", "", 1, "btn", "btn-primary", "btn-block", "font-weight-bold", "px-4", "mt-lg-0", 3, "disabled", "confirmContent", "valid", "confirm"], [1, "mb-2"], [1, "auction-description-title", "pt-2", "pb-2", "pr-2", "pl-0", "mb-0", "mt-5", "mr-3"], [1, "border-top", "border-disabled", "mt-0", "mb-2"], ["id", "description", 3, "description"], ["confirmContent", ""], [4, "ngFor", "ngForOf"], ["ngbSlide", ""], ["draggable", "false", 1, "card-img", 3, "src", "alt", "useDefault", "loyaltyType"], [1, "status", "winning", "position-absolute", "p-0", "text-center", "text-on-success", "font-size-14"], [1, "font-weight-bold"], [1, "status", "outbid", "position-absolute", "p-0", "text-center", "text-on-success", "font-size-14"], [1, "mb-3", "mb-lg-0", "mr-4", "justify-content-center", "align-items-center"], ["theme", "auction", 3, "isActive", "minValue", "maxValue", "incrementValue", "minMessage", "maxMessage", "amount", "outOfRange", "limitValueToRange", "amountChange", "outOfRangeChange"], [1, "text-center"], [1, "auction-modal-title"], [1, "mt-0", "mx-5"], [1, "row", "my-5"], [1, "col-lg-2", "col-3", "d-flex", "justify-content-center"], ["draggable", "false", 1, "confirm-modal-image", "shadow", "rounded", 3, "src", "alt", "useDefault", "loyaltyType"], [1, "col-lg-10", "col-9", "pl-0"], [1, "auction-modal-item-name", "mb-1"], [1, "auction-modal-points-value", "mb-0"]], template: function AuctionDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AuctionDetailsComponent_div_0_Template, 51, 33, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.auction$));
    } }, directives: [ɵngcc3.NgIf, ɵngcc4.ErrorsComponent, ɵngcc5.LoyaltyIconComponent, ɵngcc3.NgSwitch, ɵngcc3.NgSwitchCase, ɵngcc6.CountdownComponent, ɵngcc7.ConfirmModalDirective, ɵngcc8.ShortLongDescriptionComponent, ɵngcc2.NgbCarousel, ɵngcc3.NgForOf, ɵngcc2.NgbSlide, ɵngcc9.ImgDefaultDirective, ɵngcc10.NumberInputComponent], pipes: [ɵngcc3.AsyncPipe, ɵngcc11.TranslatePipe, ɵngcc3.DecimalPipe, ɵngcc12.ContentImagePipe], styles: [".card-img-overlay[_ngcontent-%COMP%]{font-size:18px}.btn-block[_ngcontent-%COMP%], button[_ngcontent-%COMP%]{font-size:.875rem}.btn-block[_ngcontent-%COMP%]{min-width:172px;height:34px}"] });
AuctionDetailsComponent.ctorParameters = () => [
    { type: AuctionService },
    { type: AuctionQuery },
    { type: BalanceQuery },
    { type: BalanceService },
    { type: ErrorStateService },
    { type: NgbCarouselConfig },
    { type: SignalRHub }
];
AuctionDetailsComponent.propDecorators = {
    auctionId: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuctionDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-auction-details',
                template: "<div *ngIf=\"auction$ | async as auction\" class=\"container\">\r\n  <!-- Server Side Errors -->\r\n  <fgbcl-errors></fgbcl-errors>\r\n  <div class=\"d-block d-lg-flex mt-lg-3 pt-lg-3\">\r\n    <!-- Image -->\r\n    <div class=\"loyalty-details-image card shadow rounded border-0 overflow-hidden p-0\">\r\n      <ng-container *ngIf=\"auction.Images && auction.Images.length > 1; else singleImage\">\r\n        <ngb-carousel>\r\n          <ng-template ngbSlide *ngFor=\"let image of auction.Images\">\r\n            <img\r\n              class=\"card-img\"\r\n              src=\"{{ image.ImageUrl | contentImage: '7':'auction' }}\"\r\n              alt=\"{{ image.ImageUrl }}\"\r\n              [useDefault]=\"true\"\r\n              [loyaltyType]=\"'marketplace'\"\r\n              draggable=\"false\"\r\n            />\r\n          </ng-template>\r\n        </ngb-carousel>\r\n      </ng-container>\r\n      <ng-template #singleImage>\r\n        <img\r\n          class=\"card-img\"\r\n          src=\"{{ auction.ImageUrl | contentImage: '7':'auction' }}\"\r\n          [alt]=\"auction.ItemName\"\r\n          [useDefault]=\"true\"\r\n          [loyaltyType]=\"'marketplace'\"\r\n          draggable=\"false\"\r\n        />\r\n      </ng-template>\r\n      <div class=\"card-img-overlay d-flex flex-column justify-content-between p-0\">\r\n        <!-- Corner Icon -->\r\n        <fgbcl-loyalty-icon class=\"corner-icon bg-auction text-on-auction\" loyaltyType=\"auction\"></fgbcl-loyalty-icon>\r\n        <!-- Auction Status -->\r\n        <ng-container [ngSwitch]=\"auction.Status\">\r\n          <div\r\n            *ngSwitchCase=\"auctionStatus.UserWinning\"\r\n            class=\"status winning position-absolute p-0 text-center text-on-success font-size-14\"\r\n          >\r\n            <span class=\"font-weight-bold\">{{ 'auction.winning.status' | translate }}</span>\r\n          </div>\r\n          <div\r\n            *ngSwitchCase=\"auctionStatus.UserLosing\"\r\n            class=\"status outbid position-absolute p-0 text-center text-on-success font-size-14\"\r\n          >\r\n            <span class=\"font-weight-bold\">{{ 'auction.outbid.status' | translate }}</span>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n    <!-- Details -->\r\n    <div class=\"loyalty-details w-100\">\r\n      <h2 class=\"auction-detail-name mt-0 pl-0 pl-lg-3 pt-4 pt-lg-0\">{{ auction.ItemName }}</h2>\r\n      <!-- Card Body -->\r\n      <div class=\"card-body d-flex flex-column justify-content-between pr-3 pl-0 pl-lg-3 pb-4 pt-2 pt-lg-3\">\r\n        <!-- Item Details -->\r\n        <div class=\"row mb-2\">\r\n          <!-- Current Bid Value  -->\r\n          <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\">\r\n            <span\r\n              class=\"icon material-icons auction-icons-color mr-2\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'auction.details.points.screenreader' | translate }}\"\r\n              >emoji_events</span\r\n            >\r\n            <span class=\"font-size-18 pt-1\">{{ this.currentValue | number }} Pts</span>\r\n          </div>\r\n          <!-- Bid Count -->\r\n          <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\">\r\n            <span\r\n              class=\"icon material-icons auction-icons-color mr-2\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'auction.details.bids.count.screenreader' | translate }}\"\r\n              >gavel</span\r\n            >\r\n            <span class=\"font-size-18 pt-1\">{{ this.bidsCount | number }} Bids</span>\r\n          </div>\r\n          <!-- End Time -->\r\n          <div class=\"col-6 col-lg-4 d-flex align-items-center pb-3\">\r\n            <span\r\n              class=\"icon material-icons auction-icons-color mr-2\"\r\n              role=\"img\"\r\n              attr.aria-label=\"{{ 'auction.details.countdown.screenreader' | translate }}\"\r\n              >schedule</span\r\n            >\r\n            <fgbcl-countdown\r\n              class=\"font-size-18 pt-1 countdown-color\"\r\n              [endDateTime]=\"this.endDate\"\r\n              (complete)=\"auctionEnd = $event\"\r\n            ></fgbcl-countdown>\r\n          </div>\r\n        </div>\r\n        <!-- Bottom Buttons -->\r\n        <div class=\"row pt-lg-4\">\r\n          <div class=\"d-flex pl-2 p-0\">\r\n            <div\r\n              class=\"mb-3 mb-lg-0 mr-4 justify-content-center align-items-center\"\r\n              *ngIf=\"\r\n                auctionEnd || comingSoon || auction.PointsValue > this.availableBalance || (isWinning && !auction.AllowSelfBid)\r\n                  ? false\r\n                  : true\r\n              \"\r\n            >\r\n              <fgbcl-number-input\r\n                [isActive]=\"auctionEnd || comingSoon || (isWinning && !auction.AllowSelfBid) ? false : true\"\r\n                [minValue]=\"auction.HasPreviousSuccessfulBid ? currentValue + auction.BidIncrement : currentValue\"\r\n                [maxValue]=\"availableBalance\"\r\n                [incrementValue]=\"auction.BidIncrement\"\r\n                [minMessage]=\"'error.auctionBid-valueLowerThanMinimumBidValue' | translate: { minBid: minBidAmount }\"\r\n                [maxMessage]=\"'error.user-insufficientFunds' | translate\"\r\n                [(amount)]=\"bidAmount\"\r\n                [(outOfRange)]=\"isBidOutOfRange\"\r\n                theme=\"auction\"\r\n                [limitValueToRange]=\"false\"\r\n              >\r\n              </fgbcl-number-input>\r\n            </div>\r\n            <div class=\"d-flex mr-3\">\r\n              <button\r\n                [disabled]=\"\r\n                  (isWinning && !auction.AllowSelfBid) ||\r\n                  comingSoon ||\r\n                  bidAmount > availableBalance ||\r\n                  auctionEnd ||\r\n                  isBidOutOfRange\r\n                \"\r\n                class=\"btn btn-primary btn-block font-weight-bold px-4 mt-lg-0\"\r\n                confirmModal\r\n                [confirmContent]=\"confirmContent\"\r\n                [valid]=\"!auctionEnd\"\r\n                (confirm)=\"submitBid()\"\r\n              >\r\n                {{ statusText | translate }}\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- Description & Terms  -->\r\n        <div class=\"mb-2\">\r\n          <label class=\"auction-description-title pt-2 pb-2 pr-2 pl-0 mb-0 mt-5 mr-3\">{{\r\n            'auction.description' | translate\r\n          }}</label>\r\n          <hr class=\"border-top border-disabled mt-0 mb-2\" />\r\n          <fgbcl-short-long-description id=\"description\" [description]=\"auction.ItemDescription\"> </fgbcl-short-long-description>\r\n        </div>\r\n        <!-- Confirm Modal Content -->\r\n        <ng-template #confirmContent>\r\n          <p class=\"text-center\">\r\n            <b class=\"auction-modal-title\">{{ 'auction.confirm.text' | translate }}</b>\r\n          </p>\r\n          <hr class=\"mt-0 mx-5\" />\r\n          <div class=\"row my-5\">\r\n            <div class=\"col-lg-2 col-3 d-flex justify-content-center\">\r\n              <img\r\n                class=\"confirm-modal-image shadow rounded\"\r\n                src=\"{{ auction.ImageUrl | contentImage: '7':'auction' }}\"\r\n                alt=\"{{ auction.ImageUrl }}\"\r\n                [useDefault]=\"true\"\r\n                [loyaltyType]=\"'auction'\"\r\n                draggable=\"false\"\r\n              />\r\n            </div>\r\n            <div class=\"col-lg-10 col-9 pl-0\">\r\n              <div class=\"auction-modal-item-name mb-1\">{{ auction.ItemName }}</div>\r\n              <div class=\"auction-modal-points-value mb-0\">\r\n                <span class=\"font-weight-bold\">{{ 'auction.points.value' | translate }}</span>\r\n                <span> {{ bidAmount | number }}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [".card-img-overlay{font-size:18px}.btn-block,button{font-size:.875rem}.btn-block{min-width:172px;height:34px}"]
            }]
    }], function () { return [{ type: ɵngcc1.AuctionService }, { type: ɵngcc1.AuctionQuery }, { type: ɵngcc1.BalanceQuery }, { type: ɵngcc1.BalanceService }, { type: ɵngcc1.ErrorStateService }, { type: ɵngcc2.NgbCarouselConfig }, { type: ɵngcc1.SignalRHub }]; }, { auctionId: [{
            type: Input
        }] }); })();

class AuctionDetailsModule {
}
AuctionDetailsModule.ɵfac = function AuctionDetailsModule_Factory(t) { return new (t || AuctionDetailsModule)(); };
AuctionDetailsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuctionDetailsModule });
AuctionDetailsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ErrorsModule,
            NumberInputModule,
            ShortLongDescriptionModule,
            PipesModule,
            LoyaltyIconModule,
            CountdownModule,
            DirectivesModule,
            ConfirmModalModule,
            RouterModule,
            NgbCarouselModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuctionDetailsModule, { declarations: function () { return [AuctionDetailsComponent]; }, imports: function () { return [CommonModule,
        ErrorsModule,
        NumberInputModule,
        ShortLongDescriptionModule,
        PipesModule,
        LoyaltyIconModule,
        CountdownModule,
        DirectivesModule,
        ConfirmModalModule,
        RouterModule,
        NgbCarouselModule, ɵngcc11.TranslateModule]; }, exports: function () { return [AuctionDetailsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuctionDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [AuctionDetailsComponent],
                imports: [
                    CommonModule,
                    ErrorsModule,
                    NumberInputModule,
                    ShortLongDescriptionModule,
                    PipesModule,
                    LoyaltyIconModule,
                    CountdownModule,
                    DirectivesModule,
                    ConfirmModalModule,
                    RouterModule,
                    NgbCarouselModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [AuctionDetailsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AuctionDetailsComponent, AuctionDetailsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-auctions-auction-details.js.map